export const PREFILLED_CARD_DATA_CACHE_KEY = 'GET_BLINQ_PREFILLED_INFO_FROM_CARD_PAGE';

export const REFERRAL_DATA_CACHE_KEY = 'GET_BLINQ_REFERRAL_TRACKING_DATA';

export const OPAQUE_TOKEN_CACHE_KEY = 'GET_BLINQ_OPAQUE_TOKEN';

export const CELLO_REFERRAL_CACHE_KEY = 'GET_BLINQ_CELLO_REFERRAL_CODE';

/** Query parameter Cello appends to the referral link's destination URL. */
export const CELLO_REFERRAL_QUERY_STRING = 'ucc';

/** Base64-encoded referrer name Cello appends alongside the referral code. */
export const CELLO_REFERRER_NAME_QUERY_STRING = 'celloN';

export const ACCEPTABLE_PREFILLED_CARD_DATA_QUERY_STRINGS = [
  '_dl',
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'jobTitle',
  'orgName',
] as const;

export type ReferralDataQueryStringKey =
  (typeof ACCEPTABLE_PREFILLED_CARD_DATA_QUERY_STRINGS)[number];
